import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

/** Horizontally scrollable on small screens. */
export const Table = ({ className, ...props }: HTMLAttributes<HTMLTableElement>) => (
  <div className="w-full overflow-x-auto">
    <table className={cn("w-full border-collapse text-left text-sm", className)} {...props} />
  </div>
);
export const THead = (props: HTMLAttributes<HTMLTableSectionElement>) => (
  <thead className="border-b border-border text-xs text-subtle uppercase" {...props} />
);
export const TBody = (props: HTMLAttributes<HTMLTableSectionElement>) => (
  <tbody className="divide-y divide-border" {...props} />
);
export const TR = (props: HTMLAttributes<HTMLTableRowElement>) => <tr {...props} />;
export const TH = ({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) => (
  <th
    scope="col"
    className={cn("px-4 py-2.5 font-medium whitespace-nowrap", className)}
    {...props}
  />
);
export const TD = ({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) => (
  <td className={cn("px-4 py-3 align-middle", className)} {...props} />
);
